import { action } from 'satcheljs/lib/legacy';
import acceptSharedCalendarInvite from '../services/acceptSharedCalendarInvite';
import selectNewCalendar from '../services/selectNewCalendar';
var acceptInvite = action('acceptInvite')(function acceptInvite(sharingInviteItemId) {
    return acceptSharedCalendarInvite(sharingInviteItemId).then(function (response) {
        if (response.ResponseClass == 'Success' && response.NewCalendarEntryId) {
            // select the new calendar
            selectNewCalendar(response.NewCalendarEntryId.Id);
        }
        return new Promise(function (resolve) {
            resolve(response.ResponseClass == 'Success');
        });
    });
});
export default acceptInvite;
//# sourceMappingURL=acceptInvite.js.map